<template>
  <div class="goods_add">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="APPID" prop="app_id">
        <el-input v-model="ruleForm.app_id"></el-input>
      </el-form-item>
        <el-form-item label="token" prop="token">
            <el-input v-model="ruleForm.token"></el-input>
        </el-form-item>
        <el-form-item label="secret" prop="secret">
            <el-input v-model="ruleForm.secret"></el-input>
        </el-form-item>


      <div class="mt-20"></div>

      <el-form-item class="quill-editor-top" >
        <el-button
          type="primary"
          @click="submitForm('ruleForm',2)"
          v-if="isAction=='edit'"
          >编辑配置</el-button >


              <el-button
                      type="primary"
                      @click="submitForm('ruleForm',1)"
                      v-if="isAction=='add'"

              >添加配置</el-button
              >


      </el-form-item>
    </el-form>
    <el-card>





    </el-card>

  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {



      id: 0,
      isAction:"",
      ruleForm: {
          app_id: "",

          token: "",
          secret:"",

      },
      dialogVisible: false,

      rules: {
          app_id: [
          {
            required: true,
            message: "请输入app_id",
            trigger: "blur",
          },
        ],
          token: [
              {
                  required: true,
                  message: "请输入Token",
                  trigger: "blur",
              },
          ],
          secret: [
              {
                  required: true,
                  message: "请输入secret",
                  trigger: "blur",
              },
          ],
      },
    };
  },
  computed: {
    ...mapState({
        config: (state) => state.wechat_menu.result,

    }),
  },
  methods: {
    ...mapActions({
        configWechatAction:"configWechatAction"

    }),






    saveData(type) {

        this.configWechatAction({
            app_id: this.ruleForm.app_id,
            secret: this.ruleForm.secret,
            app_token:this.ruleForm.token,
            type:type,
            id:this.id
        });

    },
    submitForm(formName,type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveData(type);
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  created() {
    this.configWechatAction({type:0});
  },
  watch: {

      config(newdata) {


      if (newdata.code == 400) {

          this.isAction="add"


      }
          if (newdata.code == 301) {

              this.isAction="edit"
              this.$message({
                  message: '微信配置添加成功',
                  type: 'success'
              });
              this.configWechatAction({type:0});
          }
          if (newdata.code == 302) {

              this.isAction="edit"
              this.$message({
                  message: '微信配置成功',
                  type: 'success'
              });

          }
          if (newdata.code == 200) {

              this.isAction="edit"
              this.ruleForm.app_id=newdata.data.app_id
              this.ruleForm.token=newdata.data.token
              this.ruleForm.secret=newdata.data.secret
              this.id=newdata.data.id
              // this.$message({
              //     message: '角色添加成功',
              //     type: 'success'
              // });

          }





    },
  },
};
</script>



<style>


.avatar-uploader .el-upload {
  border: 1px dashed #260a0a;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
}

.el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 90px !important;
}

.el-upload-list--picture-card .el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
  line-height: 90px !important;
}

.title_bg {
  background-color: #f5fffa;
  padding: 10px;
}

.el-form-item__content {
  margin-left: 30px;
}
</style>
